import { ThemeProvider } from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider, SnackbarOrigin } from 'notistack';
import LuxonUtils from '@date-io/luxon';

import { AuthProvider } from './contexts/auth';
import { SnackbarUtilsSetup } from './utils/snackbarUtils';
import GlobalCss from './theme/global';
import theme from './theme'
import Routes from './routes'
import { CarsProvider } from './pages/Fleets/context/cars';

const snackBarOptions: SnackbarOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

export default function App() {
  return (
    <MuiPickersUtilsProvider utils={LuxonUtils} locale="pt-BR">
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={snackBarOptions}
          >
            <CarsProvider>
              <SnackbarUtilsSetup />
              <CssBaseline />
              <GlobalCss />
              <Routes />
            </CarsProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </AuthProvider>
    </MuiPickersUtilsProvider>
  );
}